import React from 'react';
import LogoWithTrademark from '#app/components/LogoWithTrademark';
import { LinkBlock, CommentBlock } from './styles';

/**
 * Переиспользуемый компонент: ссылка с логотипом (LogoWithTrademark в светлой теме) и опциональной подписью.
 * @param {string} href - URL ссылки
 * @param {string} logo - URL картинки логотипа (src для img)
 * @param {string} [brand='whiteswan'] - 'whiteswan' | 'blackswan' — бренд (blackswan: в alternate font-size 13px)
 * @param {string} [title] - Текст над логотипом (по умолчанию "белый лебедь" / "черный лебедь" в зависимости от brand)
 * @param {React.ReactNode} [comment] - Подпись под блоком (опционально)
 * @param {Object} [commentStyle] - Стили для обёртки подписи (опционально)
 */
function PartnerLogoLink({ href, logo, brand = 'whiteswan', title, comment, commentStyle }) {
  const defaultTitle = brand === 'blackswan' ? 'черный лебедь' : 'белый лебедь';
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <LinkBlock className="other-swan-link">
        <LogoWithTrademark
          theme="light"
          variant="alternate"
          brand={brand}
          contentOnly
          src={logo}
          title={title ?? defaultTitle}
        />
      </LinkBlock>
      {comment != null && <CommentBlock style={commentStyle}>{comment}</CommentBlock>}
    </a>
  );
}

export default PartnerLogoLink;
